import { createContext } from 'react'

const DaycareWizardContext = createContext()
export default DaycareWizardContext
